import { cpfRegex } from "./regex-constants";
import type { CountryCode } from "@hopper-b2b/types";

export const getNationalIdInfo = (nationality: CountryCode) => {
  switch (nationality) {
    case "BR":
      return {
        length: { min: 14, max: 14, formatted: 11 },
        // Format: 000.000.000-00
        format: (id: string) =>
          id.slice(0, 3) +
          "." +
          id.slice(3, 6) +
          "." +
          id.slice(6, 9) +
          "-" +
          id.slice(9),
        formatPayload: (id: string) => id?.replace(/[.-]/g, ""),
        regex: cpfRegex,
        additionalValidation: (id: string) => {
          /**
           * ids that should pass:
           * 11144477735
           * 52398680002
           * 05830033542
           * 06865086376
           *
           * ids that shouldn't pass:
           * 10433218196
           * 00133890838
           * 63794026542
           * 35116155940
           *
           */

          // Helper function to determine if it's a valid CPF number
          const numberCheck = (id: string, factor: number) => {
            const sum = id
              // Swap to array
              .split("")
              // only grab the numbers that we need
              .slice(0, factor - 1)
              .reduce(
                (currTotal, number, index) =>
                  (currTotal += parseInt(number) * (factor - index)),
                0
              );
            const remainder = sum % 11;
            return remainder < 2 ? 0 : 11 - remainder;
          };

          // Validate first check digit
          const firstNumberCheck = numberCheck(id, 10);
          const secondNumberCheck = numberCheck(id, 11);
          if (
            firstNumberCheck === parseInt(id[9]) &&
            secondNumberCheck === parseInt(id[10])
          ) {
            return true;
          }
          return false;
        },
        onChange: (updatedValue, addCharacter) => {
          if (updatedValue.length <= 14) {
            if (addCharacter) {
              // Adding characters
              if (updatedValue.length === 3 || updatedValue.length === 7) {
                updatedValue = updatedValue + ".";
              } else if (updatedValue.length === 11) {
                updatedValue = updatedValue + "-";
              }
            } else {
              // Deleting characters
              if (updatedValue.length === 3 || updatedValue.length === 7) {
                updatedValue = updatedValue.slice(0, -1);
              } else if (updatedValue.length === 11) {
                updatedValue = updatedValue.slice(0, -1);
              }
            }
            return updatedValue;
          }
          return updatedValue.slice(0, -1);
        },
        label: "CPF",
      };
    default:
      return null;
  }
};
